import React, { useState } from "react";

import { proposallistData } from "../../../core/data/json/proposallist";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
  activeList,
  clientList,
  currency,
  dealsselectOption,
  editreleatdselectOption,
  initialSettings,
  newselectOption,
  priorityList,
  releatdselectOption,
} from "../../../core/common/selectoption/selectoption";
import CollapseHeader from "../../../core/common/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import DatePicker from "react-datepicker";
import { TagsInput } from "react-tag-input-component";
import DefaultEditor from "react-simple-wysiwyg";
import { all_routes } from "../../router/all_routes";
import Proposalsgrid from "./proposalsgrid";
import AddOrcamentoForm from './AddOrcamentoForm';

interface IOrcamento {
  id: string;
  data: string;
  produto: string;
  sendTo: string;
  client_img: string;
  quantidade: number;
  valor: number;
  percentualConcluido: number;
  situacao: 'Aprovado' | 'Pendente' | 'Em análise';
}

interface IColumn {
  title: string;
  dataIndex?: keyof IOrcamento;
  key: string;
  sorter?: boolean;
  render?: (text: any, record?: IOrcamento) => React.ReactNode;
}

const Proposalslist = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const data = proposallistData;
  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );

  const columns: IColumn[] = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      sorter: true,
      render: (text: string): string => new Date(text).toLocaleDateString('pt-BR')
    },
    {
      title: "Produto",
      dataIndex: "produto",
      key: "produto",
      sorter: true
    },
    {
      title: "Fornecedor",
      dataIndex: "sendTo",
      key: "sendTo",
      sorter: true,
      render: (text: string, record?: IOrcamento): React.ReactNode => record ? (
        <div className="flex items-center">
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {text}
            </div>
          </div>
        </div>
      ) : null
    },
    {
      title: "Quant.",
      dataIndex: "quantidade",
      key: "quantidade",
      sorter: true
    },
    {
      title: "Total Orçado",
      dataIndex: "valor",
      key: "valor",
      sorter: true,
      render: (value: number): string => new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    },
    {
      title: "%Comp.",
      dataIndex: "percentualConcluido",
      key: "percentualConcluido",
      sorter: true,
      render: (value: number): string => `${value}%`
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      sorter: true,
      render: (text: IOrcamento['situacao']): React.ReactNode => (
        <div>
          {text === "Aprovado" && (
            <span className="badge badge-pill badge-status bg-success px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
              {text}
            </span>
          )}
          {text === "Pendente" && (
            <span className="badge badge-pill badge-status bg-warning px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
              {text}
            </span>
          )}
          {text === "Em análise" && (
            <span className="badge badge-pill badge-status bg-purple px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {text}
            </span>
          )}
        </div>
      )
    },
    {
      title: "Ações",
      key: "acoes",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit" to="#"><i className="ti ti-edit text-blue"></i> Edit</Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_proposals"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
          </div>
        </div>
      )
    }
  ];

  const [tag1, setTag1] = useState(["Tags"]);
  const [tag2, setTag2] = useState(["Tags"]);

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Orçamentos<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Pesquisar Orçamento"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-package-export me-2" />
                              Export
                            </Link>
                            <div className="dropdown-menu  dropdown-menu-end">
                              <ul>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-file-type-pdf text-danger me-1" />
                                    Export as PDF
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-file-type-xls text-green me-1" />
                                    Export as Excel{" "}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <AddOrcamentoForm />
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>

                  <div className="card-body">
                    <>
                      {/* Filter */}
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">

                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-sort-ascending-2 me-2" />
                              Ordenar{" "}
                            </Link>
                            <div className="dropdown-menu dropdown-menu-start">
                              <ul>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-circle-chevron-right me-1" />
                                    Crescente
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-circle-chevron-right me-1" />
                                    Decrescente
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-circle-chevron-right me-1" />
                                    Visualizados Recentemente
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                  >
                                    <i className="ti ti-circle-chevron-right me-1" />
                                    Adicionados Recentemente
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="icon-form">
                            <span className="form-icon">
                              <i className="ti ti-calendar" />
                            </span>
                            <DateRangePicker
                              initialSettings={{
                                startDate: '01/01/2025',
                                endDate: '09/01/2025',
                                locale: {
                                  format: 'DD/MM/YYYY',
                                  applyLabel: 'Aplicar',
                                  cancelLabel: 'Cancelar',
                                  fromLabel: 'De',
                                  toLabel: 'Até',
                                  customRangeLabel: 'Personalizado',
                                  daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                                  monthNames: [
                                    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                                    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
                                  ],
                                  firstDay: 0
                                },
                                opens: 'left'
                              }}
                            >
                              <input
                                className="form-control bookingrange"
                                type="text"
                                placeholder="Selecione uma data"
                              />
                            </DateRangePicker>
                          </div>
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="btn bg-soft-purple text-purple"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="outside"
                            >
                              <i className="ti ti-columns-3 me-2" />
                              Gerenciar Colunas
                            </Link>
                            <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                              <h4 className="mb-2 font-semibold">
                                Deseja gerenciar as colunas da tabela?
                              </h4>
                              <p className="mb-3">
                                Arraste e solte as colunas para reordenar sua tabela e habilite as opções conforme desejado.
                              </p>
                              <div className="border-t pt-3">
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Data Vencimento
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-data" className="check" />
                                    <label htmlFor="col-data" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Data Pagamento
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-empresa" className="check" />
                                    <label htmlFor="col-empresa" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Descrição
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-descricao" className="check" />
                                    <label htmlFor="col-descricao" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Total
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-situacao" className="check" />
                                    <label htmlFor="col-situacao" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Total a Pagar
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-valor" className="check" />
                                    <label htmlFor="col-valor" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between mb-3">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Situação
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-saldo" className="check" />
                                    <label htmlFor="col-saldo" className="checktoggle" />
                                  </div>
                                </div>
                                <div className="d-flex items-center justify-between">
                                  <p className="mb-0 d-flex items-center">
                                    <i className="ti ti-grip-vertical me-2" />
                                    Ações
                                  </p>
                                  <div className="status-toggle">
                                    <input type="checkbox" id="col-acoes" className="check" />
                                    <label htmlFor="col-acoes" className="checktoggle" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-sorts dropdown me-2">
                            <Link
                              to="#"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="outside"
                            >
                              <i className="ti ti-filter-share" />
                              Filtro
                            </Link>
                            <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                              <div className="filter-set-view">
                                <div className="filter-set-head">
                                  <h4>
                                    <i className="ti ti-filter-share" />
                                    Filtro
                                  </h4>
                                </div>
                                <div className="accordion" id="accordionExample">
                                  {/* ID do Orçamento */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseId"
                                        aria-expanded="true"
                                        aria-controls="collapseId"
                                      >
                                        ID do Orçamento
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse show"
                                      id="collapseId"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar ID"
                                          />
                                        </div>
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                #2024001
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                #2024002
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Período */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapsePeriodo"
                                        aria-expanded="false"
                                        aria-controls="collapsePeriodo"
                                      >
                                        Período
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapsePeriodo"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Último mês
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Últimos 3 meses
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Últimos 6 meses
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Produtos */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseProdutos"
                                        aria-expanded="false"
                                        aria-controls="collapseProdutos"
                                      >
                                        Produtos
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapseProdutos"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar Produto"
                                          />
                                        </div>
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Sistema de Gestão Municipal
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Portal da Transparência
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Sistema de RH
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Fornecedor */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFornecedor"
                                        aria-expanded="false"
                                        aria-controls="collapseFornecedor"
                                      >
                                        Fornecedor
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapseFornecedor"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar Fornecedor"
                                          />
                                        </div>
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                TechSoft Solutions
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Municipal Systems SA
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Licitante */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseLicitante"
                                        aria-expanded="false"
                                        aria-controls="collapseLicitante"
                                      >
                                        Licitante
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapseLicitante"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar Licitante"
                                          />
                                        </div>
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Prefeitura de São Paulo
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Governo do Estado de SP
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Situação */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSituacao"
                                        aria-expanded="false"
                                        aria-controls="collapseSituacao"
                                      >
                                        Situação
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapseSituacao"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Negociando
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Finalizado
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Cancelado
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Usuário */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head">
                                      <Link
                                        to="#"
                                        className="collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseUsuario"
                                        aria-expanded="false"
                                        aria-controls="collapseUsuario"
                                      >
                                        Usuário
                                      </Link>
                                    </div>
                                    <div
                                      className="filter-set-contents accordion-collapse collapse"
                                      id="collapseUsuario"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="filter-content-list">
                                        <div className="mb-2 icon-form">
                                          <span className="form-icon">
                                            <i className="ti ti-search" />
                                          </span>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar Usuário"
                                          />
                                        </div>
                                        <ul>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                João Silva
                                              </label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input type="checkbox" />
                                                <span className="checkmarks" />
                                                Maria Santos
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                                <div className="filter-reset-btns">
                                  <div className="row">
                                    <div className="col-6">
                                      <Link to="#" className="btn btn-light">
                                        Limpar
                                      </Link>
                                    </div>
                                    <div className="col-6">
                                      <Link to="#" className="btn btn-primary">
                                        Filtrar
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="view-icons">
                            <Link to={route.ProposalsList} className="active">
                              <i className="ti ti-list-tree" />
                            </Link>
                            <Link to={route.ProposalsGrid}>
                              <i className="ti ti-grid-dots" />
                            </Link>
                          </div>
                        </div>
                      </div>
                      {/* /Filter */}
                    </>

                    {/* Projects List */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={data} columns={columns} />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Projects List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
      <>
        {/* Add New Proposal */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Add New Proposal</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Date<span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <DatePicker
                          className="form-control datetimepicker"
                          selected={selectedDate}
                          onChange={handleDateChange}
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Open Till <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <DatePicker
                          className="form-control datetimepicker"
                          selected={selectedDate1}
                          onChange={handleDateChange1}
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Client <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={clientList}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="col-form-label">
                          Project<span className="text-danger">*</span>
                        </label>
                        <Link
                          to="#"
                          className="label-add "
                          data-bs-toggle="modal"
                          data-bs-target="#add_project"
                        >
                          <i className="ti ti-square-rounded-plus" />
                          Add New
                        </Link>
                      </div>
                      <Select
                        options={newselectOption}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Related to <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={releatdselectOption}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="col-form-label">
                          Deals<span className="text-danger">*</span>
                        </label>
                        <Link
                          to="#"
                          className="label-add "
                          data-bs-toggle="modal"
                          data-bs-target="#add_deal"
                        >
                          <i className="ti ti-square-rounded-plus" />
                          Add New
                        </Link>
                      </div>
                      <Select
                        options={releatdselectOption}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Currency</label>
                      <Select
                        options={priorityList}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={activeList}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Assigned to <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={activeList}
                        className="select"
                        placeholder="Select"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Attachment <span className="text-danger">*</span>
                      </label>
                      <div className="drag-attach">
                        <input type="file" />
                        <div className="img-upload">
                          <i className="ti ti-file-broken" />
                          Upload File
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">Tags </label>
                      <TagsInput
                        value={tag1}
                        onChange={setTag1}
                        name="tag1"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Description <span className="text-danger">*</span>
                      </label>
                      <DefaultEditor className="summernote" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#create_success"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add New Proposal */}
        {/* Edit Proposal */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Edit Proposal</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form >
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue="Web design Proposal"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Date<span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder="DD/MM/YY"
                          defaultValue="11-06-2024"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Open Till <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder="DD/MM/YY"
                          defaultValue="14-06-2024"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Client <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={clientList}
                        className="select"
                        placeholder="HarborView"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="col-form-label">
                          Project<span className="text-danger">*</span>
                        </label>
                        <Link
                          to="#"
                          className="label-add "
                          data-bs-toggle="modal"
                          data-bs-target="#add_project"
                        >
                          <i className="ti ti-square-rounded-plus" />
                          Add New
                        </Link>
                      </div>
                      <Select
                        options={newselectOption}
                        className="select"
                        placeholder="Truelysell"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Related to <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={editreleatdselectOption}
                        className="select"
                        placeholder="Deals"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="col-form-label">
                          Deals<span className="text-danger">*</span>
                        </label>
                        <Link
                          to="#"
                          className="label-add "
                          data-bs-toggle="modal"
                          data-bs-target="#add_deal"
                        >
                          <i className="ti ti-square-rounded-plus" />
                          Add New
                        </Link>
                      </div>
                      <Select
                        options={dealsselectOption}
                        className="select"
                        placeholder="Collins"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Currency</label>
                      <Select
                        options={currency}
                        className="select"
                        placeholder="$"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={activeList}
                        className="select"
                        placeholder="Open"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Assigned to <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={activeList}
                        className="select"
                        placeholder="Open"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Attachment <span className="text-danger">*</span>
                      </label>
                      <div className="drag-attach">
                        <input type="file" />
                        <div className="img-upload">
                          <i className="ti ti-file-broken" />
                          Upload File
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">Tags </label>
                      <TagsInput
                        value={tag2}
                        onChange={setTag2}
                        name="tag2"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Description <span className="text-danger">*</span>
                      </label>
                      <DefaultEditor className="summernote" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Proposal */}
        {/* Delete Proposals */}
        <div className="modal fade" id="delete_proposals" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Proposal?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> proposal you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal">
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Proposals */}
        {/* Create Proposal */}
        <div className="modal custom-modal fade" id="create_success" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0 m-0 justify-content-end">
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="success-message text-center">
                  <div className="success-popup-icon bg-light-blue">
                    <i className="ti ti-atom-2" />
                  </div>
                  <h3>Proposals Created Successfully!!!</h3>
                  <p>View the details of proposals, created</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Create Proposal */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="add_deal" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Deal</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form action="#">
                  <div className="mb-3">
                    <label className="col-form-label">Deal Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="add_project" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Project</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form action="#">
                  <div className="mb-3">
                    <label className="col-form-label">Project Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
      </>

    </div>
  );
};

export default Proposalslist;
